import type { Payline } from './types';

export const PAYLINES = Object.freeze([
  Object.freeze([1, 1, 1, 1, 1]),
  Object.freeze([0, 0, 0, 0, 0]),
  Object.freeze([2, 2, 2, 2, 2]),
  Object.freeze([0, 1, 2, 1, 0]),
  Object.freeze([2, 1, 0, 1, 2]),
  Object.freeze([0, 0, 1, 2, 2]),
  Object.freeze([2, 2, 1, 0, 0]),
  Object.freeze([1, 0, 0, 0, 1]),
  Object.freeze([1, 2, 2, 2, 1]),
  Object.freeze([0, 2, 0, 2, 0]),
] as const satisfies readonly Payline[]);

export const PAYLINE_COUNT = PAYLINES.length;

